export default __webpack_public_path__ + "static/kelli-mcclintock-kid-1-f42ae73c3ff0e31fa3d851416d504492.jpg";